import {
  FETCH_ACCESS_CODE_FAILURE,
  FETCH_ACCESS_CODE_REQUESTED,
  FETCH_ACCESS_CODE_SUCCESS,
} from 'actiontypes/accessCodes';
import AccessCodeService from 'services/AccessCodeService';

/** ----------------------------------------------------------------------------
 * FETCH ACCESSCODE
 -----------------------------------------------------------------------------*/

const fetchAccessCodeRequest = () => ({ type: FETCH_ACCESS_CODE_REQUESTED });
const fetchAccessCodeSuccess = ({ accessCode }) => ({
  type: FETCH_ACCESS_CODE_SUCCESS,
  payload: accessCode,
});
const fetchAccessCodeFailure = () => ({ type: FETCH_ACCESS_CODE_FAILURE });

export default fetchAccessCode(new AccessCodeService());

export function fetchAccessCode(service) {
  return code => async (dispatch) => {
    dispatch(fetchAccessCodeRequest());
    try {
      const { data } = await service.fetchAccessCode(code);
      if (!data.isSuccess) {
        throw new Error();
      }
      // If we asked for a valid code, then dispatch
      dispatch(fetchAccessCodeSuccess(data));
      return data;
    } catch (e) {
      // This is an invalid access code (or other failure)
      dispatch(fetchAccessCodeFailure(e));
      return e;
    }
  };
}